import { is } from 'immutable';
import { useSelector } from 'react-redux';

import { WhoamiEntity } from '@/entities';
import type { WhoamiEntityRecord } from '@/entities/Whoami';
import { createLogger } from '@/utils';

const log = createLogger('useAuth');

export const useAuth = () => {
  const user = useSelector<unknown, WhoamiEntityRecord | undefined>(
    (state) => WhoamiEntity.duck.selectors.currentUser(state),
    is,
  );
  log('%o', user);

  return user;
};

export type UseAuthReturn = ReturnType<typeof useAuth>;
